<template>
    
</template>

<script>
    export default {
        name: "ReportingIndex"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/Reporting/ReportingIndex.vue